import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignService } from '../../../services/campaign.service';
import { Campaign, CampaignBanner } from '../../../models/campaign';
import { checkIfModeExistsInQueryParams } from 'src/app/shared/utility/campaign';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @Input() showProgressBar: boolean = true;
    @Input() title: string = 'new campaign';
    steps = [
        {
            step: 1,
            url: 'step-1',
            completed: false
        },
        {
            step: 2,
            url: 'step-2',
            completed: false
        },
        {
            step: 3,
            url: 'step-3',
            completed: false
        },
        {
            step: 4,
            url: 'step-4',
            completed: false
        },
        {
            step: 5,
            url: 'step-5',
            completed: false
        }
    ];
    currCampaign: Campaign;
    currStep = { step: 1 };
    previewMode = false;
    editMode = false;
    partialEditMode = false;
    liveEditMode = false;

    public constructor(
        private router: Router,
        private campaignService: CampaignService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.getCampaign();
        this.previewMode = checkIfModeExistsInQueryParams(this.route, 'preview');
        this.partialEditMode = checkIfModeExistsInQueryParams(this.route, 'partial-edit-mode');
        this.liveEditMode = checkIfModeExistsInQueryParams(this.route, 'live-edit-mode');
        this.editMode = checkIfModeExistsInQueryParams(this.route, 'edit-mode');
    }

    getCampaign() {
        this.campaignService.getCampaignSubject().subscribe(campaign => {
            this.currCampaign = campaign;
            if (this.currCampaign != null) this.changeStepStatus();
        });
    }

    changeStepStatus() {
        this.steps.forEach(value => {
            switch (value.step) {
                case 1:
                case 2:
                    if (this.currCampaign.industryId != 0 && this.currCampaign.title != null) {
                        value.completed = true;
                    }
                    break;
                case 3:
                    if (this.currCampaign.channels != null) {
                        value.completed = true;
                    }
                    break;
                case 4:
                    if (this.currCampaign.products != null) {
                        value.completed = true;
                    }
                    break;
                case 5:
                    if (
                        this.currCampaign.products &&
                        this.currCampaign.products[0]?.media != null
                    ) {
                        value.completed = true;
                    }
                    break;
            }
        });
    }

    private stepCompletedAndCampaignNotNull(step) {
        return step.completed && this.currCampaign != null;
    }

    public navigateToUrl(nextStep): void {
        const hasValidCampaign = this.stepCompletedAndCampaignNotNull(nextStep);
        const baseUrl = `/campaign/${nextStep.url}/${this.currCampaign._id}`;
        let mode = '';
        let queryParams;

        if (this.partialEditMode) {
            queryParams = 'partial-edit-mode=true';
            mode = 'isPartialEditMode';
        }

        if (this.liveEditMode) {
            queryParams = 'live-edit-mode=true';
            mode = 'isLiveEditMode';
        }

        if (this.previewMode) {
            queryParams = ['preview=true'];
            mode = 'isPreviewMode';

            if (this.editMode) {
                queryParams.push('edit-mode=true');
                mode = 'isEditMode';
            }
        }

        switch (mode) {
            case 'isPreviewMode':
                if (hasValidCampaign) {
                    const queryString = `?${queryParams}`;
                    this.router.navigateByUrl(`${baseUrl}${queryString}`);
                }
                break;
            case 'isPartialEditMode':
                if (
                    (hasValidCampaign && nextStep.step <= this.currStep.step) ||
                    nextStep.step == 2
                ) {
                    const queryString = `?${queryParams}`;
                    this.router.navigateByUrl(`${baseUrl}${queryString}`);
                }
                break;
            case 'isLiveEditMode':
                if (hasValidCampaign && nextStep.step <= 4) {
                    const queryString = `?${queryParams}`;
                    this.router.navigateByUrl(`${baseUrl}${queryString}`);
                }
                break;
            case 'isEditMode':
                {
                    const isStep4 = nextStep.step === 4;
                    if (hasValidCampaign && isStep4) {
                        const queryString = `?${queryParams.join('&')}`;
                        this.router.navigateByUrl(`${baseUrl}${queryString}`);
                    }
                }
                break;
            default:
                if (hasValidCampaign && nextStep.step <= this.currStep.step) {
                    this.router.navigateByUrl(baseUrl);
                }
        }
    }

    public dismissBanner(banner: CampaignBanner): void {
        if (!this.currCampaign?.banners) return;
        this.currCampaign.banners = this.currCampaign.banners.filter(b => b.type !== banner.type);
        this.campaignService.dismissBanner(this.currCampaign._id, banner.type).subscribe();
    }

    public checkIfLinkActive(step): boolean {
        if (this.router.url.indexOf(step.url) > -1) {
            this.currStep = step;
            return true;
        }
        return false;
    }
}
